import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";

export const ProductCard = ({ product, layout = "stacked" }) => {
  const [qty, setQty] = useState(1);
  const { addItem } = useCart();

  const handleAdd = () => {
    addItem(
      {
        id: product.id,
        name: product.name,
        price: product.price,
        image: product.image,
        category: product.category,
      },
      qty
    );
    toast.success(`${qty} × ${product.name} added`, {
      description: "Find it in your cart, ready when you are.",
    });
  };

  return (
    <article
      data-testid={`product-card-${product.id}`}
      className="group flex flex-col"
    >
      <div className="relative zoom-on-hover aspect-[4/5] bg-shay-cream-deep">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover"
        />
        {product.tags?.includes("bestseller") && (
          <span className="absolute top-4 left-4 bg-shay-navy text-shay-gold text-[10px] tracking-[0.25em] uppercase px-3 py-1.5 rounded-full">
            Bestseller
          </span>
        )}
        {product.tags?.includes("gluten-free") && (
          <span className="absolute top-4 left-4 bg-shay-gold text-shay-navy text-[10px] tracking-[0.25em] uppercase px-3 py-1.5 rounded-full font-semibold">
            Gluten Free
          </span>
        )}
      </div>

      <div className="pt-5 flex flex-col flex-1">
        <p className="eyebrow">
          {product.category === "cookies"
            ? "Cookie"
            : product.category === "oatmeal"
            ? "Oatmeal"
            : "Brownie"}
        </p>
        <h3 className="font-display text-2xl md:text-[1.6rem] leading-tight mt-1 text-shay-navy">
          {product.name}
        </h3>
        <p className="mt-2.5 text-sm text-shay-chocolate/80 leading-relaxed flex-1">
          {product.description}
        </p>
        <div className="mt-5 flex items-end justify-between">
          <div>
            <p className="text-[10px] uppercase tracking-widest text-shay-brown">From</p>
            <p className="font-display text-2xl text-shay-navy" data-testid={`product-price-${product.id}`}>
              ${product.price.toFixed(2)}
              <span className="text-xs ml-2 text-shay-chocolate/60 font-sans">/ each</span>
            </p>
          </div>
          <div className="inline-flex items-center border border-shay-navy/20 rounded-full">
            <button
              onClick={() => setQty((q) => Math.max(1, q - 1))}
              data-testid={`product-qty-decrease-${product.id}`}
              className="h-9 w-9 grid place-items-center hover:text-shay-gold"
              aria-label="Decrease"
            >
              <Minus size={14} />
            </button>
            <span className="w-7 text-center text-sm font-medium" data-testid={`product-qty-${product.id}`}>{qty}</span>
            <button
              onClick={() => setQty((q) => q + 1)}
              data-testid={`product-qty-increase-${product.id}`}
              className="h-9 w-9 grid place-items-center hover:text-shay-gold"
              aria-label="Increase"
            >
              <Plus size={14} />
            </button>
          </div>
        </div>
        <button
          onClick={handleAdd}
          data-testid={`add-to-cart-${product.id}`}
          className="btn-gold w-full mt-5"
        >
          Add to Cart
        </button>
      </div>
    </article>
  );
};

export default ProductCard;
